import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import 'focus-visible';
import styles from './styles.module.css';
const NOREFERRER_REGEX = /^(\/|(https?:\/\/)?(www\.)?(([^.]+)\.)*(lemanapro\.ru|lemanapro\.kz))/;
/**
 * `<BaseButton />` —  базовый компонент кнопки, без оформления, для реализации своей кнопки.
 *
 * @example ```tsx
 * <BaseButton>TEXT</BaseButton>
 * ```
 */
export const BaseButton = /*#__PURE__*/forwardRef(function BaseButton({
  className = '',
  children,
  withExtraClickZone = false,
  as = 'button',
  rel,
  disabled,
  'data-testid': testId = 'button',
  ...props
}, ref) {
  const classNames = useMemo(() => clsx(styles.button, className, {
    [styles.extraClickZone]: withExtraClickZone
  }), [className, withExtraClickZone]);
  let ComponentProp = as;
  let buttonProps = {};
  if (ComponentProp === 'button' && props.href) {
    ComponentProp = 'a';
  }
  if (props.href) {
    if (rel) {
      buttonProps.rel = rel;
    } else {
      buttonProps.rel = NOREFERRER_REGEX.test(props.href) ? 'noopener' : 'noopener noreferrer';
    }
  }
  if (ComponentProp === 'button') {
    var _props$type;
    buttonProps.type = (_props$type = props.type) != null ? _props$type : 'button';
    buttonProps.disabled = disabled;
  } else {
    if (ComponentProp !== 'a' || !props.href) {
      buttonProps.role = 'button';
    }
    if (disabled) {
      buttonProps['aria-disabled'] = disabled;
    }
  }
  return /*#__PURE__*/React.createElement(ComponentProp, {
    ref: ref,
    className: classNames,
    "data-testid": testId,
    ...buttonProps,
    ...props
  }, children);
});